'use client';

import React__default, { useState, useCallback } from 'react';
import AlertIcon from '../Images/AlertIcon/index.js';
import RemoveIcon from '../Images/RemoveIcon/index.js';
import { colors } from '../Utils/constants.js';
import { AlertWrapper, Icon, CloseButton } from './Alert.css.js';

var Alert = /*#__PURE__*/ React__default.memo(function (props) {
    var type = props.type, children = props.children, style = props.style, onClick = props.onClick, onClickClose = props.onClickClose, _a = props.isHaveClose, isHaveClose = _a === void 0 ? true : _a, iconType = props.iconType;
    var _b = useState(false), isClosed = _b[0], setClose = _b[1];
    var _c = useState(false), isRemoved = _c[0], setRemove = _c[1];
    var getColor = function () {
        switch (type) {
            case 'success':
                return colors.successColor;
            case 'error':
                return colors.dangerColor;
            case 'info':
                return colors.infoColor;
            case 'warning':
                return colors.highlightColor;
            default:
                return colors.successColor;
        }
    };
    var handleOnClick = useCallback(function () {
        onClick && onClick();
    }, [onClick]);
    var handleOnClose = useCallback(function () {
        setClose(true);
        onClickClose && onClickClose();
    }, [onClickClose]);
    return isRemoved ? (React__default.createElement(React__default.Fragment, null)) : (React__default.createElement(AlertWrapper, { isClosed: isClosed, type: type, style: style, onClick: handleOnClick, onAnimationEnd: function () { return setRemove(true); }, isHaveClose: isHaveClose, isHaveIcon: !!iconType },
        iconType === 'warning' && (React__default.createElement(Icon, null,
            React__default.createElement(AlertIcon, { color: getColor() }))),
        React__default.createElement("div", null, children),
        isHaveClose && (React__default.createElement(CloseButton, { onClick: handleOnClose },
            React__default.createElement(RemoveIcon, null)))));
});

export { Alert as default };
//# sourceMappingURL=index.js.map
